import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=f5a24e54&scoped=true"
var script = {}
import style0 from "./tabbar.vue?vue&type=style&index=0&id=f5a24e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a24e54",
  null
  
)

export default component.exports